import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-50c4be66")
const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = { class: "p-col-2 p-d-flex p-jc-center" }
const _hoisted_3 = { style: {"position":"relative","width":"150px","height":"300px","overflow":"hidden"} }
const _hoisted_4 = {
  key: 1,
  class: "profile-photo-container",
  id: "cont",
  style: {"position":"relative","border":"1px solid"}
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  class: "pi pi-camera",
  style: {"position":"absolute","top":"40%","font-size":"2rem"}
}
const _hoisted_7 = {
  key: 2,
  class: "uploadImg"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-upload",
  style: {"font-size":"1rem","cursor":"pointer"}
}, null, -1)
const _hoisted_9 = { class: "p-col-10" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h4", null, "Datos personales", -1)
const _hoisted_11 = { class: "p-formgrid p-grid p-fluid" }
const _hoisted_12 = { class: "p-field p-col" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "firstname" }, "Nombre", -1)
const _hoisted_14 = {
  key: 0,
  class: "form-error validationError"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Requerido")
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "p-field p-col" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "lastname" }, "Apellido", -1)
const _hoisted_20 = {
  key: 0,
  class: "form-error validationError"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Requerido")
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { class: "p-field p-col" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { for: "dni" }, "DNI", -1)
const _hoisted_26 = {
  key: 0,
  class: "form-error validationError"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Debe ser númerico")
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = { class: "p-field p-col" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { for: "pais" }, "País", -1)
const _hoisted_32 = {
  key: 0,
  class: "form-error validationError"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Requerido")
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h4", null, "Datos de contacto", -1)
const _hoisted_37 = { class: "p-formgrid p-grid p-fluid" }
const _hoisted_38 = { class: "p-field p-col-6" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1)
const _hoisted_40 = {
  key: 0,
  class: "form-error validationError"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Mail no válido")
const _hoisted_43 = [
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = { class: "p-field p-col-3" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { for: "phone" }, "Teléfono", -1)
const _hoisted_46 = {
  key: 0,
  class: "form-error validationError"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle" }, null, -1)
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" Número no válido")
const _hoisted_49 = [
  _hoisted_47,
  _hoisted_48
]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("h4", null, "Cursos que puede dar", -1)
const _hoisted_51 = { class: "p-formgrid p-grid p-fluid" }
const _hoisted_52 = { class: "p-field p-col-6" }
const _hoisted_53 = { class: "p-formgrid p-grid p-fluid" }
const _hoisted_54 = {
  class: /*#__PURE__*/_normalizeClass('p-col-6')
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("h4", null, "Estado", -1)
const _hoisted_56 = { class: "p-formgrid p-grid p-fluid" }
const _hoisted_57 = { class: "p-field-checkbox p-col-4" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { for: "postulado" }, "Postulado", -1)
const _hoisted_59 = { class: "p-field-checkbox p-col-4" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", { for: "aprobado" }, "Aprobado", -1)
const _hoisted_61 = { class: "p-field-checkbox p-col-4" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { for: "consideracionfutura" }, "Consideración futura", -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("h4", null, "Rol", -1)
const _hoisted_64 = { class: "p-formgrid p-grid p-fluid" }
const _hoisted_65 = { class: "p-field-checkbox p-col-4" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { for: "teacher" }, "Profesor", -1)
const _hoisted_67 = { class: "p-field-checkbox p-col-4" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { for: "tutor" }, "Tutor", -1)
const _hoisted_69 = { class: "p-field-checkbox p-col-4" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", { for: "coordinator" }, "Coordinador", -1)
const _hoisted_71 = { class: "p-col-12" }
const _hoisted_72 = {
  key: 0,
  class: "d-flex align-items-end flex-column",
  style: {"width":"100%"}
}
const _hoisted_73 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_74 = { class: "p-2" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BrainSpinner = _resolveComponent("BrainSpinner")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_CoursesMultipleSelector = _resolveComponent("CoursesMultipleSelector")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_CommentBox = _resolveComponent("CommentBox")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loadingImg)
          ? (_openBlock(), _createBlock(_component_BrainSpinner, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("img", {
                src: _ctx.StaffCreate.profile.avatar || require('@/assets/person-no-image.png')
              }, null, 8, _hoisted_5),
              _withDirectives(_createElementVNode("i", _hoisted_6, null, 512), [
                [_vShow, !_ctx.StaffCreate.profile.avatar]
              ])
            ])),
        (!_ctx.loadingImg)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("input", {
                id: "fileUp",
                onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChangeFile($event))),
                type: "file",
                ref: "file",
                style: {"display":"none"}
              }, null, 544),
              _createVNode(_component_Button, {
                class: "p-button-icon-only",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$refs.file.click())),
                style: {"width":"fit-content"}
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_component_InputText, {
            modelValue: _ctx.v$.firstName.$model,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.firstName.$model = $event)),
            id: "firstname",
            type: "text",
            placeholder: "Nombre"
          }, null, 8, ["modelValue"]),
          (_ctx.v$.firstName.$errors[0]?.$validator == 'required')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_17))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createVNode(_component_InputText, {
            modelValue: _ctx.v$.lastName.$model,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.lastName.$model = $event)),
            id: "lastname",
            type: "text",
            placeholder: "Apellido"
          }, null, 8, ["modelValue"]),
          (_ctx.v$.lastName.$errors[0]?.$validator == 'required')
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_23))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createVNode(_component_InputText, {
            id: "dni",
            type: "text",
            placeholder: "DNI",
            modelValue: _ctx.v$.dni.$model,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.dni.$model = $event))
          }, null, 8, ["modelValue"]),
          (_ctx.v$.dni.$errors[0]?.$validator == 'numeric' || _ctx.v$.dni.$errors[0]?.$validator == 'required')
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_29))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createVNode(_component_Dropdown, {
            onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeCountry($event))),
            id: "pais",
            modelValue: _ctx.v$.country.$model,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.country.$model = $event)),
            options: _ctx.countries,
            optionLabel: "name",
            optionValue: "code",
            placeholder: "Seleccionar País"
          }, null, 8, ["modelValue", "options"]),
          (_ctx.v$.country.$errors[0]?.$validator == 'required')
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_35))
            : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_36,
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _hoisted_39,
          _createVNode(_component_InputText, {
            modelValue: _ctx.v$.email.$model,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.v$.email.$model = $event)),
            id: "email",
            type: "email",
            placeholder: "Email"
          }, null, 8, ["modelValue"]),
          (_ctx.v$.email.$errors[0]?.$validator == 'required' || _ctx.v$.email.$errors[0]?.$validator == 'email')
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_43))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_44, [
          _hoisted_45,
          _createVNode(_component_InputText, {
            modelValue: _ctx.v$.phone.$model,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.v$.phone.$model = $event)),
            id: "phone",
            type: "phone",
            placeholder: "Teléfono"
          }, null, 8, ["modelValue"]),
          (_ctx.v$.phone.$errors[0]?.$validator == 'numeric' || _ctx.v$.phone.$errors[0]?.$validator == 'minLengthValue' || _ctx.v$.phone.$errors[0]?.$validator == 'required')
            ? (_openBlock(), _createElementBlock("div", _hoisted_46, _hoisted_49))
            : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_50,
      _createElementVNode("div", _hoisted_51, [
        _createElementVNode("div", _hoisted_52, [
          _createVNode(_component_CoursesMultipleSelector, {
            disabled: _ctx.loading,
            coursePlans: _ctx.coursePlans,
            modelValue: _ctx.modelCourses,
            selectedRol: _ctx.selectedRol,
            placeholder: "Seleccionar Cursos",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.setCanBeTeacherOf($event))),
            onChangeRolCanBeTeacherOf: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changeRolCanBeTeacherOf($event)))
          }, null, 8, ["disabled", "coursePlans", "modelValue", "selectedRol"])
        ])
      ]),
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("div", null, [
            _hoisted_55,
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _createVNode(_component_Checkbox, {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setState(_ctx.StaffCreate.interview.applied, 'applied'))),
                  binary: true,
                  modelValue: _ctx.inApplied,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.inApplied = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_58
              ]),
              _createElementVNode("div", _hoisted_59, [
                _createVNode(_component_Checkbox, {
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.setState(_ctx.StaffCreate.interview.approved, 'approved'))),
                  binary: true,
                  modelValue: _ctx.inApprobed,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.inApprobed = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_60
              ]),
              _createElementVNode("div", _hoisted_61, [
                _createVNode(_component_Checkbox, {
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.setState(_ctx.StaffCreate.interview.notNow, 'notNow'))),
                  binary: true,
                  modelValue: _ctx.inNotNow,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.inNotNow = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_62
              ])
            ]),
            _hoisted_63,
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("div", _hoisted_65, [
                _createVNode(_component_Checkbox, {
                  disabled: true,
                  binary: true,
                  modelValue: _ctx.StaffCreate.roles.teacher,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.StaffCreate.roles.teacher = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_66
              ]),
              _createElementVNode("div", _hoisted_67, [
                _createVNode(_component_Checkbox, {
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.setRoles(_ctx.StaffCreate.roles.assistant, 'tutor'))),
                  binary: true,
                  modelValue: _ctx.inTutor,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.inTutor = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_68
              ]),
              _createElementVNode("div", _hoisted_69, [
                _createVNode(_component_Checkbox, {
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.setRoles(_ctx.StaffCreate.roles.coordinator, 'coordinator'))),
                  binary: true,
                  modelValue: _ctx.inCoordinator,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.inCoordinator = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_70
              ])
            ])
          ])
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_71, [
      _createVNode(_component_CommentBox, {
        personId: _ctx._idUser,
        loading: !_ctx.showComments,
        comments: _ctx.comments,
        onOnSave: _ctx.onCommentBoxSaveEvent
      }, null, 8, ["personId", "loading", "comments", "onOnSave"])
    ], 512), [
      [_vShow, _ctx.showComments]
    ]),
    (!_ctx.showComments)
      ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
          _hoisted_73,
          _createElementVNode("div", _hoisted_74, [
            _createVNode(_component_Button, {
              onClick: _ctx.saveStaff,
              class: "p-button",
              label: "Guardar Perfil",
              style: {"float":"right"}
            }, null, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}